var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6689 10.6167C11.6689 10.8744 11.46 11.0833 11.2023 11.0833H2.80228C2.54454 11.0833 2.33561 10.8744 2.33561 10.6167V3.38333C2.33561 3.1256 2.54455 2.91667 2.80228 2.91667H6.53561C6.79334 2.91667 7.00228 2.70773 7.00228 2.45V2.21667C7.00228 1.95893 6.79334 1.75 6.53561 1.75H1.63561C1.37788 1.75 1.16895 1.95893 1.16895 2.21667V11.7833C1.16895 12.0411 1.37788 12.25 1.63561 12.25H12.3689C12.6267 12.25 12.8356 12.0411 12.8356 11.7833V6.88333C12.8356 6.6256 12.6267 6.41667 12.3689 6.41667H12.1356C11.8779 6.41667 11.6689 6.6256 11.6689 6.88333V10.6167Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1678 1.25509L9.66103 1.76182C9.47879 1.94406 9.47879 2.23953 9.66103 2.42178L11.5759 4.33669C11.7582 4.51893 12.0537 4.51893 12.2359 4.33669L12.7426 3.82997C12.9249 3.64772 12.9249 3.35225 12.7426 3.17001L10.8277 1.25509C10.6455 1.07285 10.35 1.07285 10.1678 1.25509Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8362 3.24698C8.65396 3.06473 8.35848 3.06473 8.17624 3.24698L5.96774 5.45548C5.88022 5.54299 5.83105 5.66169 5.83105 5.78546V7.70033C5.83105 7.95806 6.03999 8.16699 6.29772 8.16699H8.21259C8.33636 8.16699 8.45505 8.11783 8.54257 8.03031L10.7511 5.82181C10.9333 5.63956 10.9333 5.34409 10.7511 5.16184L8.8362 3.24698Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.bf621c69989dbc3172a4e9b2f848785f.svg";
export { ForwardRef as ReactComponent };